module.exports = __webpack_public_path__ + "img/statements.024deeb8.svg";